export const WIDGET_FILES_EMPTY_STATE = 'WIDGET_FILES_EMPTY_STATE';
export const WIDGET_FILES_LIST_CONTAINER = 'WIDGET_FILES_LIST_CONTAINER';
